import { requestUser } from "utils/axiosInstance"
import { BuyProductRequest, BuyProductResponse } from "../../types"

const buyProduct = async (payload: BuyProductRequest) => {
  const res = await requestUser.post<BuyProductResponse>("/user/buy", payload)
  return res
}

export default buyProduct
